import { Injectable } from '@angular/core';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { DeleteCommandHandler } from '../../../core/service/command/delete-command-handler.service';
import { EditCommandHandler } from '../../../core/service/command/edit-command-handler.service';
import { standardCommand } from '../../../core/model/command';
import { CompanyExportCommandHandler } from './company-export-command-handler.service';
import { companyCommand } from '../../command/company.command';
import { CompanyCloseAccountingPeriodCommandHandler } from './company-close-accounting-period-command-handler.service';

@Injectable()
export class CompanyCommandHandlerResolver extends CommandHandlerResolver {
  constructor(
    deleteHandler: DeleteCommandHandler,
    editHandler: EditCommandHandler,
    exportHandler: CompanyExportCommandHandler,
    closeAccountingPeriodHandler: CompanyCloseAccountingPeriodCommandHandler
  ) {
    super();
    this.addHandler(standardCommand.delete, deleteHandler);
    this.addHandler(standardCommand.edit, editHandler);
    this.addHandler(companyCommand.export, exportHandler);
    this.addHandler(companyCommand.closeAccountingPeriod, closeAccountingPeriodHandler);
  }
}
